import { IconSet } from '@postscript/components';
import React from 'react';
import { logButtonClickEvent, PRODUCT_AREAS } from 'utils/events';
import SidebarLauncherButton from './SidebarLauncherButton';

interface NotificationsLauncherProps {
  notificationCount: number;
  isPanelOpen: boolean;
  onClick: () => void;
}

const NotificationsLauncher: React.FC<NotificationsLauncherProps> = ({
  notificationCount,
  isPanelOpen,
  onClick,
}) => {
  const hasNotifications = notificationCount > 0;
  const showBadge = hasNotifications && !isPanelOpen;
  const icon =
    hasNotifications || isPanelOpen ? IconSet.BellRinging : IconSet.Bell;

  const badgeProps = showBadge
    ? {
        children: notificationCount > 99 ? '99+' : notificationCount.toString(),
        variant: 'error' as const,
        style: {
          background: 'var(--red-5)',
          borderRadius: 'var(--border-radius-round)',
          color: 'var(--white)',
          fontWeight: 'bold',
        },
      }
    : undefined;

  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    logButtonClickEvent(event, {
      action: 'notifications button clicked',
      location: 'footer',
      notification_count: notificationCount,
      product_area: PRODUCT_AREAS.GLOBAL,
    });
    onClick();
  };

  return (
    <SidebarLauncherButton
      icon={icon}
      label="Notifications"
      isPanelOpen={isPanelOpen}
      hasActiveState={hasNotifications}
      onClick={handleClick}
      badge={badgeProps}
      data-cy="footer-notifications-button"
      aria-label={`Notifications${
        notificationCount > 0 ? ` (${notificationCount})` : ''
      }`}
    />
  );
};

export default NotificationsLauncher;
